import React from "react";
import css from "./CustomConfigSection.module.css";
import {FeatureExplorer,FileNavigator,FileView,NoticeView,SectionView,TextView} from "Components";
import {configfilelocation0} from "Assets";


export default function CustomConfigSection(){
    return (
        <SectionView 
            className={css.customconfigsection}
            title="custom configuration" 
            text={`
                if the above configuration is not sufficient, you can customize it and make your own.
                @to customize the default vritra configuartion, add a 
                <b>vritra.config.js</b> file in the root folder of your app.
            `}
        >
            <FileNavigator 
                files={[{content:statics.vritraconfigfile.object}]}
                preview={configfilelocation0}
            />
            <FeatureExplorer feature={{sections:[statics.docs.ignore]}}/>
            <NoticeView text={`
                The <span>vritra.config.js</span> follows the same configuration schema 
                as any typical <span>webpack.config.js</span> file.
                @Only <span>definitions</span> and <span>ignore</span> entries are vritra-config-specific.
            `}/>
            <TextView text="The config file can export a function that returns an object as well:"/>
            <FileView content={statics.vritraconfigfile.function}/>
            <FeatureExplorer feature={{sections:[statics.docs.env]}}/>
            <NoticeView text={`
                note that not everything is customizable, some configuration is still
                required for the app to build and start as expected.
                @if the vritra.config.js file still does not suit your needs, you can
                <a 
                    href="#getstarted#availablescripts#npmrunextract" 
                    target="_self"
                >build</a> your own configuration.
            `}/>
        </SectionView>
    )
}

const statics={
    docs:{
        ignore:{fields:[{
            name:"ignore",
            type:"array",
            description:`
                specifies which node modules vritra-scripts should ignore
                @The item can be either a <span>RegExp</span>, an <a href="https://webpack.js.org/plugins/ignore-plugin/">object</a>
                or a <span>string</span> to target exact matches.
                @available since version <b>1.1.0</b>
            `,
        }]},
        env:{fields:[
            {
                name:"env",type:"object",
                description:`
                    configuration environment.
                    @value depends on the command used to start/build the app.
                `,
                props:[
                    {
                        name:"id",type:`"dev"|"test"|"prod"`,
                    },
                    {name:"name",type:`"development"|"testing"|"production"`},
                ],
            },
            {
                name:"args",type:"string[]",
                description:"arguments passed to the command."
            }
        ]},
    },
    
    vritraconfigfile:{
        function:'<div><span style="color: #4ec9b0;">module</span>.<span style="color: #4ec9b0;">exports</span><span style="color: #d4d4d4;">=</span>({<span style="color: #9cdcfe;">env</span>,<span style="color: #9cdcfe;">args</span>})<span style="color: #569cd6;">=&gt;</span>({</div><div>&nbsp; &nbsp; <span style="color: #6a9955;">/* Webpack configs */</span></div><div>});</div>',
        object:'<div><span style="color: #4ec9b0;">module</span>.<span style="color: #4ec9b0;">exports</span><span style="color: #d4d4d4;">=</span>{</div><div>&nbsp; &nbsp; <span style="color: #9cdcfe;">definitions</span><span style="color: #9cdcfe;">:</span>{</div><div>&nbsp; &nbsp; &nbsp; &nbsp; <span style="color: #6a9955;">/* New Custom Definitions */</span></div><div>&nbsp; &nbsp; },</div><div>&nbsp; &nbsp; <span style="color: #9cdcfe;">ignore</span><span style="color: #9cdcfe;">:</span>[</div><div>&nbsp; &nbsp; &nbsp; &nbsp; <span style="color: #6a9955;">/* Node modules to ignore */</span></div><div>&nbsp; &nbsp; ],</div><div>&nbsp; &nbsp; <span style="color: #9cdcfe;">devServer</span><span style="color: #9cdcfe;">:</span>{</div><div>&nbsp; &nbsp; &nbsp; &nbsp; <span style="color: #9cdcfe;">port</span><span style="color: #9cdcfe;">:</span><span style="color: #b5cea8;">3333</span>,<span style="color: #6a9955;">//changes test/dev server port to 3333</span></div><div>&nbsp; &nbsp; },</div><div>&nbsp; &nbsp; <span style="color: #9cdcfe;">plugins</span><span style="color: #9cdcfe;">:</span>[</div><div>&nbsp; &nbsp; &nbsp; &nbsp; <span style="color: #6a9955;">/* Extra Webpack Plugins */</span></div><div>&nbsp; &nbsp; ],</div><div>&nbsp; &nbsp; <span style="color: #9cdcfe;">resolve</span><span style="color: #9cdcfe;">:</span>{</div><div>&nbsp; &nbsp; &nbsp; &nbsp; <span style="color: #9cdcfe;">alias</span><span style="color: #9cdcfe;">:</span>{</div><div>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <span style="color: #6a9955;">/* New Custom Import Aliases */</span></div><div>&nbsp; &nbsp; &nbsp; &nbsp; },</div><div>&nbsp; &nbsp; },</div><div>&nbsp; &nbsp; <span style="color: #6a9955;">/* Other Webpack configs */</span></div><div>};</div>',
    },
}
